export default __webpack_public_path__ + "static/media/lavazemjanebi.09730bad.png";